import { StatusIndicator } from "components/partials/status-indicator/status-indicator";

import { type StatusIndicatorProps } from "components/partials/status-indicator/status-indicator.types";

const ClientReviewStatusIndicator = ({ versionStatuses }: StatusIndicatorProps) => {
  return (
    <div className="flex shrink-0 flex-col items-start text-sm">
      <span className="font-normal text-gray-500">Client Review Status</span>
      <div className="flex flex-col items-start py-0.5">
        <StatusIndicator versionStatuses={versionStatuses} />
      </div>
    </div>
  );
};

export default ClientReviewStatusIndicator;
